import { loadGLightbox } from "common/glightbox-loader";

import "./jiffymade-landing-gallery.scss";

const $getGallery = () => document.querySelector(".js-jiffymade-landing-gallery");
const $getImages = () => document.querySelectorAll(".js-jiffymade-landing-jiffy-image");

const IMAGE_LOAD_TIMEOUT_MS = 10000;

const loadImage = src =>
  new Promise(resolve => {
    const $image = new Image();

    const cleanup = () => {
      $image.onload = null;
      $image.onerror = null;
    };

    const timeoutId = setTimeout(() => {
      cleanup();
      resolve(false);
    }, IMAGE_LOAD_TIMEOUT_MS);

    $image.onload = () => {
      clearTimeout(timeoutId);
      cleanup();
      resolve(true);
    };

    $image.onerror = () => {
      clearTimeout(timeoutId);
      cleanup();
      resolve(false);
    };

    $image.src = src;
  });

const SWAP_IMAGE_INTERVAL = 3000;
const FADE_IN_CLASS = "jiffymade-landing-gallery__image--fade-in";
const FADE_OUT_CLASS = "jiffymade-landing-gallery__image--fade-out";
const FULL_IMAGE_PARAMS = "auto=format";

const getBaseUrl = url => url.split("?")[0];

const appendQueryParams = (url, params) => {
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${params}`;
};

const getAllImages = () => {
  const $gallery = $getGallery();
  if (!$gallery) return [];
  try {
    return JSON.parse($gallery.dataset.allImages || "[]");
  } catch {
    return [];
  }
};

let lightbox;
let allImages = [];
let currentImages = [];
let otherImages = [];
const loadPromises = {};

const showLightbox = index => {
  lightbox?.openAt(index);
};

const swapRandomImage = async () => {
  if (otherImages.length === 0 || currentImages.length === 0) return;

  const previousImageIndex = Math.floor(Math.random() * currentImages.length);
  const newImageIndex = Math.floor(Math.random() * otherImages.length);

  const newImage = otherImages[newImageIndex];
  const newImageSrc = newImage;

  if (currentImages.includes(newImage)) {
    await swapRandomImage();
    return;
  }

  otherImages[newImageIndex] = currentImages[previousImageIndex];
  currentImages[previousImageIndex] = newImage;

  const promise = loadPromises[newImage] || (loadPromises[newImage] = loadImage(newImageSrc));

  await promise;

  const $images = $getImages();
  const $imageToSwap = $images[previousImageIndex];
  $imageToSwap.classList.remove(FADE_IN_CLASS);
  $imageToSwap.classList.add(FADE_OUT_CLASS);
  $imageToSwap.src = newImageSrc;

  await new Promise(resolve => {
    setTimeout(resolve, 300);
  });

  $imageToSwap.classList.remove(FADE_OUT_CLASS);
  $imageToSwap.classList.add(FADE_IN_CLASS);
};

const initGLightbox = () => {
  const initializeGLightbox = () => {
    lightbox = window?.GLightbox({
      elements: allImages.map(image => ({
        href: appendQueryParams(getBaseUrl(image), FULL_IMAGE_PARAMS),
        type: "image"
      })),
      touchNavigation: true,
      loop: false,
      autoplayVideos: false
    });
  };

  loadGLightbox(initializeGLightbox);
};

const initImageSwap = () => {
  const initialPromises = currentImages.map(image => loadImage(image));

  Promise.allSettled(initialPromises).then(() => {
    const swap = () => {
      setTimeout(async () => {
        await swapRandomImage();
        swap();
      }, SWAP_IMAGE_INTERVAL);
    };
    swap();
  });
};

export const initGallery = () => {
  const currentBaseUrls = Array.from($getImages()).map($image => getBaseUrl($image.src));
  allImages = getAllImages();
  currentImages = allImages.filter(image => currentBaseUrls.includes(getBaseUrl(image)));
  otherImages = allImages.filter(image => !currentBaseUrls.includes(getBaseUrl(image)));

  initGLightbox();
  $getImages().forEach(($image, index) => {
    $image.addEventListener("click", () => {
      const currentImage = currentImages[index];
      const imageIndex = allImages.indexOf(currentImage);
      if (imageIndex !== -1) {
        showLightbox(imageIndex);
      }
    });
  });

  initImageSwap();
};

export default initGallery;
